// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { AddManualTimeRequest } from "generated/wisetime/user/timeline/v4/timeline_pb"
import {
  SearchRecentManualTimeCommentsRequest
} from "generated/wisetime/user/preferences/v4/preferences_pb"

export const searchRecentManualTimeComments = createAction<SearchRecentManualTimeCommentsRequest>("manual-time/search-recent-manual-time-comments")

export const addManualTime = createAction<AddManualTimeRequest>("manual-time/add-manual-time")
export const addManualTimeFulfilled = createAction("manual-time/add-manual-time-fulfilled")

export const activityPersisted = createAction("manual-time/activity-persisted")
export const activityPersistFailed = createAction("manual-time/activity-persist-failed")
export const loadActivityFromStorage = createAction("manual-time/load-activity-from-storage")
export const loadActivityFromStorageFailed = createAction("manual-time/load-activity-from-storage-failed")
